import { Box, Button, Spinner } from '@chakra-ui/react';
import firebase from 'lib/firebase';
import React from 'react';
import { PortalRoot } from './PortalRoot';
import { LoginPage } from './pages/LoginPage';
import devBorderStyles from './style/devBorder.module.css';

function App(): JSX.Element {
  const [userStatus, setUserStatus] = React.useState('loading');
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [isSecuritas, setIsSecuritas] = React.useState(false);
  function logout(): void {
    firebase.auth().signOut();
  }
  React.useEffect(() => {
    firebase.auth().onAuthStateChanged(async function (user) {
      setUserStatus(user ? 'logged_in' : 'logged_out');
    });
  }, []);
  React.useEffect(() => {
    if (userStatus === 'logged_in') {
      firebase
        .auth()
        .currentUser?.getIdTokenResult()
        .then((idTokenResult) => {
          // Confirm the user is an Admin.
          if (
            idTokenResult.claims?.roles.includes('portal:admin') ||
            idTokenResult.claims?.roles.includes('portal:securitas')
          ) {
            // Show admin UI.
            if (idTokenResult.claims?.roles.includes('portal:admin')) {
              setIsAdmin(true);
            }
            if (idTokenResult.claims?.roles.includes('portal:securitas')) {
              setIsSecuritas(true);
            }
          } else {
            // Show regular user UI.
            setIsAdmin(false);
          }
        })
        .catch((error) => {
          setIsAdmin(false);
          console.log(error);
        });
    }
  }, [userStatus]);

  return (
    <AppWrap>
      {userStatus === 'loading' ? (
        <div style={{ position: 'fixed', top: '50%', left: '50%' }}>
          <Spinner />
        </div>
      ) : userStatus === 'logged_out' ? (
        <LoginPage />
      ) : (userStatus === 'logged_in' && isAdmin) || isSecuritas ? (
        <PortalRoot />
      ) : (
        <Box>
          <p>Rättigheter saknas</p>
          <Box>
            <Button onClick={logout}>Logga ut</Button>
          </Box>
        </Box>
      )}
    </AppWrap>
  );
}

function AppWrap({ children }: { children: React.ReactNode }) {
  const isStaging = process.env.REACT_APP_ENV === 'staging';

  if (isStaging) {
    return <div className={devBorderStyles.devBorder}>{children}</div>;
  }

  return <>{children}</>;
}

export default App;
